/* panel-header.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0V36Ow%7Bheight%3A3.5rem%7D%0A._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D%0A._0hPCNLDIqT%7Balign-items%3Acenter%7D%0A._0LQT5EkG2W%7Bpadding-inline-start%3Avar(--ds-space-250%2C20px)%7D%0A._03SyCPkG2W%7Bpadding-inline-end%3Avar(--ds-space-250%2C20px)%7D%0A._46hvQm5zaO%7Bpadding-block-start%3Avar(--ds-space-200%2C1pc)%7D%0A._0xmtko5zaO%7Bpadding-block-end%3Avar(--ds-space-200%2C1pc)%7D%0A._2mHwu82ADO%7Bgap%3Avar(--ds-space-100%2C8px)%7D%0A._37wbyuI7V3%7Bjustify-content%3Aspace-between%7D%0A._39xV02N91d%7Bwidth%3A100%25%7D");









import type { ReactNode } from 'react';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Flex } from '@atlaskit/primitives/compiled/flex';
export interface PanelHeaderProps {
  /**
   * The content of the panel header.
   */
  children: ReactNode;
  /**
   * A unique string that appears as data attribute `data-testid` in the rendered code, serving as a hook for automated tests.
   */
  testId?: string;
}
const styles = {
  header: "_0jFU0V36Ow _3iDTPbQ4SZ _0hPCNLDIqT _0LQT5EkG2W _03SyCPkG2W _46hvQm5zaO _0xmtko5zaO",
  headerContent: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _39xV02N91d"
};

/**
 * The PanelHeader component provides a standardized header area for panels
 * containing the title, actions, and other header-specific content.
 * It automatically organizes content into left (back button + title) and right (actions) sections
 * using flexbox layout. Place PanelActionGroup as the last child to position it on the right.
 */
export function PanelHeader({
  children,
  testId
}: PanelHeaderProps): JSX.Element {
  return <Box as="header" testId={testId} xcss={styles.header}>
			<Flex xcss={styles.headerContent}>{children}</Flex>
		</Box>;
}